import { ChangeDetectorRef, Component, Inject, OnDestroy, OnInit, PLATFORM_ID } from '@angular/core';
import { Router, RouterOutlet, RouterLink, RouterLinkActive } from '@angular/router';
import { Database, Script, ScriptName, viewFile, viewMetaData } from '../../../models/database';
import { DatabaseService } from '../../services/database/database.service';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { catchError, finalize, take } from 'rxjs/operators';
import { of, Subject } from 'rxjs';
import { ScriptViewComponentComponent } from '../../shared/script-view-component/script-view-component.component';
import { FaqModalComponentComponent } from '../../shared/faq-modal-component/faq-modal-component.component';
import { QsModalComponentComponent } from '../../shared/qs-modal-component/qs-modal-component.component';
import { LoadingServiceService } from '../../services/loadingService/loading-service.service';
import { DataShareService } from '../../services/data_share/data-share.service';
import { MsalService } from '@azure/msal-angular';

@Component({
  selector: 'app-dashboard-page',
  standalone: true,
  imports: [RouterLink, RouterLinkActive, CommonModule],
  templateUrl: './dashboard-page.component.html',
  styleUrl: './dashboard-page.component.scss'
})
export class DashboardPageComponent implements OnInit, OnDestroy {

  databases: Database[] = [];
  errorMessage: string | null = null;
  scripts: Script[] = [];
  displayScripts: Script[] = [];
  script_Count: number = 0;
  database_count: number = 0;
  presentUser: string | null = ''
  private destroy$ = new Subject<void>();
  today: Date = new Date();

  constructor(
    private databaseService: DatabaseService,
    private modalService: NgbModal,
    public loadService: LoadingServiceService,
    private cdRef: ChangeDetectorRef,
    private dataShare: DataShareService,
    private msalService: MsalService,
    @Inject(PLATFORM_ID) private platformId: Object,
  ) { }

  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      this.loadDatabases()
      this.loadScripts()
      this.loadService.show()
      this.cdRef.detectChanges();

      const activeAccount = this.msalService.instance.getActiveAccount();
      if (activeAccount) {
        this.presentUser = activeAccount.name || activeAccount.username || 'User';
      } else {
        const accounts = this.msalService.instance.getAllAccounts();
        if (accounts.length > 0) {
          this.msalService.instance.setActiveAccount(accounts[0]);
          this.presentUser = accounts[0].name || accounts[0].username || 'User';
        }
      }  
    }
  }


  loadDatabases(): void {
    //const sessionID = sessionStorage.getItem('Session_Id')
    this.databaseService.getDatabases().subscribe((data) => {
      this.databases = data;
      this.database_count = this.databases.length
      // console.log(data);
    });
  }

  loadScripts() {
    const params = {
      sort_by: 'date',
      limit: 15
    }
    //const sessionID = sessionStorage.getItem('Session_Id')
    this.databaseService.getScriptNames(params).pipe(
      finalize(() => this.loadService.hide())
    ).subscribe((data: ScriptName) => {
      if (data && data.scripts) {
        this.scripts = data.scripts
        this.script_Count = data.total_records
        this.displayScripts = this.scripts
        //.slice(0, 20);
      } else {
        console.error("Check for API Breakpoints")
      }
    })
  }

  viewFile(script_name: string, fileType: 'script' | 'validation') {
    this.loadService.show()
   // const sessionID = sessionStorage.getItem('Session_Id')
    this.databaseService.getScriptContent(script_name, fileType ).pipe(
      finalize(() => this.loadService.hide()),
      catchError(error => {
        // console.error(`Error Viewing Script ${filename}:`, error)
        this.errorMessage = "Error Loading Script Content"
        return of(null)
      })
    ).subscribe((content: viewFile | null) => {

      if (content) {
        const modalRef = this.modalService.open(ScriptViewComponentComponent, {
          size: 'xl',
          backdrop: 'static',
          keyboard: false
        });
        modalRef.componentInstance.heading = `${content.script_name}`;
        modalRef.componentInstance.message = fileType === 'script' ? content.script_content.trim() : content.validation_content.trim()
        modalRef.componentInstance.fileType = this.getFileType(content.script_name)
      }
      else {
        this.errorMessage = 'Error While loading the Script'
      }
    })
  }
  viewMetadataFile(script_path: string) {
    this.loadService.show()
    //const sessionID = sessionStorage.getItem('Session_Id')
    this.databaseService.getMetadataContent(script_path).pipe(
      finalize(() => this.loadService.hide()),
      catchError(error => {
        // console.error(`Error Viewing Script ${filename}:`, error)
        this.errorMessage = "Error Loading Script Content"
        return of(null)
      })
    ).subscribe((content: viewMetaData | null) => {

      if (content) {
        const modalRef = this.modalService.open(ScriptViewComponentComponent, {
          size: 'xl',
          backdrop: 'static',
          keyboard: false
        });
        modalRef.componentInstance.heading = `${content.metadata_filename}`;
        modalRef.componentInstance.message = JSON.stringify(content.metadata_content.content, null, 2);
        modalRef.componentInstance.fileType = 'json'
      }
      else {
        this.errorMessage = 'Error While loading the Script'
      }

    })
  }

  getFileType(filename: string): 'python' | 'json' | 'text' {
    if (filename.endsWith('.py')) {
      return 'python';
    } else if (filename.endsWith('.json')) {
      return 'json';
    } else {
      return 'text';
    }
  }
  openQucikGuide() {
    this.loadService.show()
    this.databaseService.getQUCIKSTART().pipe(
      take(1),
      finalize(() => this.loadService.hide()),
    ).subscribe((data) => {
      const modalRef = this.modalService.open(QsModalComponentComponent, {
        size: 'xl',
        backdrop: 'static',
        keyboard: false,
        centered: true
      });
      modalRef.componentInstance.qas = data;
    });
  }

  openFAQSection() {
    this.loadService.show()
    this.databaseService.getFAQSection().pipe(
      take(1),
      finalize(() => this.loadService.hide()),
    ).subscribe((data) => {
      const modalRef = this.modalService.open(FaqModalComponentComponent, {
        size: 'xl',
        backdrop: 'static',
        keyboard: false,
        centered: true
      });
      modalRef.componentInstance.faqs = data;
    });
  }
  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
